import branchManagementAverageDailyVaultBalanceComponent from './average_daily_vault_balance.component';

let branchManagementAverageDailyVaultBalanceModule = angular.module('branchManagementAverageDailyVaultBalance', [])
  .component('branchManagementAverageDailyVaultBalanceComponent', branchManagementAverageDailyVaultBalanceComponent)
  .name;

export default branchManagementAverageDailyVaultBalanceModule;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/average-daily-vault-balance/index.js